import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import axios from 'axios';
import { useState } from 'react';
import Header from './Header';
import Footer from './Footer';


function App() {
  const [data, setData] = useState([]);

  const getData = () => {

    const options = {
      method: 'GET',
      url: 'https://imdb8.p.rapidapi.com/auto-complete',
      params: { q: 'Harry Potter' },
      headers: {
        'X-RapidAPI-Key': '9f85821c35msh95df5378627c361p1dd71fjsnab79a83c5006',
        'X-RapidAPI-Host': 'imdb8.p.rapidapi.com'
      }
    };
    

    axios.request(options).then((opt) => {
      // console.log(opt.data.d[0].i.imageUrl);
      // console.log(opt.data.d[1].i.imageUrl);
      console.log(opt.data.d[0]);
      setData(opt.data.d);


    }).catch((error) => {
      console.log(error);
    });

  }
  return (
    <div className="container-fluid">
      <div className="row ">
      <Header/>
      
      </div>
      <div className="row justify-content-center bg1">
        <div className="col-12 text-center">
      <button type='button' className=" fs-5 fw-bold btn btn-dark text-info rounded mt-4" onClick={getData}>Explore & Watch</button>
      </div>
        {data.map((a, key) => {

          return (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card my-5 w-75 ms-5 " key={key}>
                <img src={a.i.imageUrl} className="card-img-top img-fluid scale" alt="" />
                <div className="card-body navbg">
                  <h5 className="card-title text-info">{a.l}</h5>
                  <p className="card-text text-light">{a.s}</p>
                  <h6 className="card-title text-light">{a.q}</h6>
                  <p className="card-text text-light">{a.y}</p>
                  <p className="card-text text-light">{a.yr}</p>
                  <button type="button" className=" fw-bold btn btn-info text-dark px-auto">Watch Now</button>
                  
                </div>
              </div>
            </div>
          );
        })}

        

      </div>
      <div className="row ">
      <Footer/>
      </div>
    </div>
  );
}
export default App;
